import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearReportNeo, reportNeoBcra } from "../../redux/actions";
import { FaRegFileExcel } from "react-icons/fa";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const ReportNeo = () => {
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [msg,setMsg]= useState("Selecciona un rango de fechas")
  const today = new Date().toISOString().split("T")[0];
  const list = useSelector((state) => state.report_neo);
  const dispatch = useDispatch();
  const UserLog = useMemo(() => JSON.parse(window.localStorage.getItem("user-log")), []);
  const [VisibleText, setVisibleText] = useState(true);

  useEffect(() => {
    console.log(list)
    return () => {
      dispatch(clearReportNeo());
    };
  }, []);

  const handleReport = async () => {
    const body = {
      inicio: desde,
      fin: hasta,
      _id: UserLog?.data_user?.id,
    };
    let response = await dispatch(reportNeoBcra(body));
    setVisibleText(response?.msg?.length > 0 ? false : true)
    response.msg?.length > 0 ? setMsg("") : setMsg("No se encontraron datos")
  };

  const exportExcel = () => {
    if (!list || list.length === 0) return alert("No hay datos para exportar");

    const worksheetData = list.map((el) => ({
      Código:el.codigo,
      Fecha: el.fecha?.slice(0,16)?.replace("T"," "),
      Nombre_Apellido_Origen: `${el.nombreOrigen} ${el.ApellidoOrigen}`,
      CVU_Origen: el.cvuOrigen,

      Tipo_Operación: el.tipo,
      Nombre_Destino:el.nombreDest ? `${el.nombreDest} ` : "-",
      CVU_Destino: el.cvuDest,
      CUIT_Destino: el.cuitDest,
      Monto: el.monto,
      Moneda: el.moneda,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = {
      Sheets: { "Reporte Neo": worksheet },
      SheetNames: ["Reporte Neo"],
    };

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    FileSaver.saveAs(blob, `Reporte_liquidacion_neo_${desde}_${hasta}.xlsx`);
  };

  return (
    <div className="container">
      <div className="d-flex align-items-center mb-3">
        <h5 className="ms-3">Reporte Liquidación Neo</h5>
      </div>
      <div className="d-flex align-items-center">
        <label htmlFor="fecha-desde">Desde</label>
        <input
          id="fecha-desde"
          className="form-control"
          type="date"
          value={desde}
          max={today}
          style={{ width: 300 }}
          onChange={(e) => setDesde(e.target.value)}
          aria-label="Fecha de inicio"
        />
        <label htmlFor="fecha-hasta">Hasta</label>
        <input
          id="fecha-hasta"
          className="form-control"
          type="date"
          max={today}
          value={hasta}
          style={{ width: 300 }}
          onChange={(e) => setHasta(e.target.value)}
          aria-label="Fecha de fin"
        />
        <button onClick={handleReport} className="btn btn-secondary ms-2">
          Buscar
        </button>
        <button
          disabled={VisibleText}
          onClick={exportExcel}
          className="btn btn-success ms-4"
        >
          <FaRegFileExcel /> Exportar Excel
        </button>
      </div>

      {!VisibleText ? (
        <table className="table mt-3">
          <thead>
            <tr>
            <th scope="col">Código</th>

              <th scope="col">Fecha</th>
              <th scope="col">Tipo</th>
              <th scope="col">Monto</th>
              <th scope="col">Origen</th>
              <th scope="col">CVU Origen</th>
              <th scope="col">Destino</th>
              <th scope="col">Cuit Destino</th>
      

              <th scope="col">CVU Destino</th>
            </tr>
          </thead>
          <tbody>
            {list.map((el, i) => (
              <tr key={i}>
                <td>{el.codigo}</td>

                <td>{el.fecha?.slice(0,16)?.replace("T"," ")}</td>
                <td>{el.tipo}</td>
                <td>{el.monto}</td>
                <td>{`${el.nombreOrigen || "-"} ${el.ApellidoOrigen}`}</td>
                <td>{el.cvuOrigen || "-"}</td>
                <td>{`${el.nombreDest || ""} ${el.ApellidoDest || ""}`}</td>
                <td>{el.cuitDest}</td>

                <td>{el.cvuDest || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="alert alert-info mt-3 ms-3">{msg}</div>
      )}
    </div>
  );
};

export default ReportNeo;
